// extracted by mini-css-extract-plugin
export default {"container":"DuLieuMonAn_container__Av0Xl","loading":"DuLieuMonAn_loading__hgebO","note":"DuLieuMonAn_note__wfJYD","search-result":"DuLieuMonAn_search-result__oInnI"};